<template>
  <el-container class="health-check-config-wrap">
    <el-header> 
       <publicBreadCrumb  :breadList="breadList"/> 
    </el-header>
    <el-main>
      <el-container style="height:100%">
        <el-aside>
          <h5 class="tag">关键康复工具配置</h5>
          <div class="type-row" v-for="(item, index) in checkTypeList" :class="[selectId === item.id ? 'active-bg' : '']"
            :key="index" @click="handleDetailContent(item)">
            <span class="type-name">{{ item.name }}</span>
            <div class="type-option">
              <el-button type="text" size="medium" @click.stop="handleDetailContent(item)">编辑</el-button>
              <!-- <span class="line-sepa"></span>
            <el-button type="text" size="medium" @click.stop="handleDelType(item)">删除</el-button> -->
            </div>
          </div>
          <!-- <el-button size="small" class="add-item" type="primary" style="margin-bottom:20px;margin-top:22px" @click="addCheckType"> + 添加一条类型</el-button> -->
        </el-aside>
        <el-main class="content-form">
          <h5 class="tag">{{ titles }}</h5>
          <el-form ref="checkForm" label-width="100px" :model="checkFormData">

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="匹配问卷：" required>
                  <el-table v-if="tableData.length !== 0" :data="tableData" :cell-style="{ textAlign: 'center' }"
                    :header-cell-style="{ textAlign: 'center', color: '#333333', fontSize: '14px', fontWeight: 'bold', backgroundColor: '#FAFAFA' }"
                    stripe style="width: 750px">
                    <el-table-column label="序号" width="180" type="index">
                      <!-- <template slot-scope="scope">
                        <span>{{scope.$index + 1}}</span>
                      </template> -->
                    </el-table-column>
                    <el-table-column prop="title" label="问卷名称" width="180">
                    </el-table-column>
                    <el-table-column  label="状态" width="180">
                       <template slot-scope="scope">
                        <span>{{scope.row.enabled?'启用':'停用'}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作">
                      <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleLook(scope.row)">查看</el-button>
                        <el-button type="text" size="small" @click="handleDel(scope.$index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-button v-if="tableData.length === 0" size="small" class="add-item-config" type="primary"
                    @click="handleShowDialog"> + 添加问卷</el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-button v-if="tableData.length !== 0" size="small" type="primary" @click="handleShowDialog"
                class="disable-btn"> + 添加问卷 </el-button>
            </el-row>
            <el-row>
              <el-col :span="24" class="footer-option">
                <!-- <el-button size="small" @click="handleCancel">取消</el-button>
                <el-button size="small" @click="handleReset">重置</el-button> -->
                <el-button type="primary" size="small" class="btn-bg" @click="saveTypeForm">保存</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-main>
      </el-container>
    </el-main>
    <!-- 添加问卷 -->
    <addQuestionDialog v-if="showAddQuestion" :showAddQuestion.sync="showAddQuestion" :showDiffQS="true"
      @receiveQuestion="receiveQuestion" />
    <!-- 预览问卷 -->
    <previewDialog v-if="showQuestion" :showQuestion.sync="showQuestion" :rowPaperId="rowPaperId" />
  </el-container>
</template>
<script>
import {
  updateToolContent,
  addRehabilitation,
  getRehabilitationList,
  getRehabilitationDetaial,
  deleteType
} from "@/api/healthToolCheckConfig";
import addQuestionDialog from "./component/addQuestionDialog";
import previewDialog from "./FormComponent/previewDialog";
import { questionnaireDetails } from "@/api/questionnaireManage";

export default {
  components: {
    addQuestionDialog,
    previewDialog
  },
  data() {
    return {
      breadList:[{name:'工具维护'},{name:'关键康复工具配置'}],
      rowPaperId: "",
      // questionnaireData: {},
      showQuestion: false,
      selectId: "",
      checkTypeList: [],
      headers: {
        Authorization: localStorage.getItem("Authorization")
      },
      checkFormData: {
        imageUrl: "",
        name: "",
        examPaperId: "",
        id: "",
        remark: ""
      },
      tableData: [],
      showAddQuestion: false,
      titles: ""
    };
  },
  async created() {
    this.getCheckTypeList();
  },
  mounted() { },
  methods: {
    addCheckType() {
      this.$refs.checkForm.resetFields();
      this.checkFormData = {
        imageUrl: "",
        name: "",
        examPaperId: "",
        id: ""
      };
      this.tableData = [];
    },
    // 接收添加的问卷
    receiveQuestion(data) {
      data.examPaperId = data.id;
      this.tableData.push(data);
    },
    async getCheckTypeList() {
      let res = await getRehabilitationList({});
      if (res.code === 0) {
        this.checkTypeList = res.data;
        if (this.checkTypeList && this.checkTypeList.length > 0) {
          this.handleDetailContent(this.checkTypeList[0])
          this.titles = this.checkTypeList[0].name
        }
      }
    },
    // // 编辑类型
    // handleEditType() {

    // },
    // 删除类型
    handleDelType(row) {
      this.$confirm("确定要删除当前测评类型吗？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-del-confirm"
      }).then(async () => {
        let res = await deleteType({
          id: row.id
        });
        if (res.code === 0) {
          this.$message.success("删除成功");
          this.getCheckTypeList();
          this.addCheckType();
        }
      });
    },
    // 获取详情
    async handleDetailContent(data) {
      this.selectId = data.id;
      this.titles = data.name;
      let res = await getRehabilitationDetaial({
        selectionId: this.selectId
      });
      if (res.code === 0) {
        if (res.data && res.data.length > 0) {
          this.tableData = [];
          res.data.forEach(item => {
            this.tableData.push({
              title: item.examPaperName,
              examPaperId: item.examPaperId,
              id: item.id,
              enabled:item.enabled
            });
          });
        } else {
          this.tableData = [];
        }
      }
    },
    // 保存
    async saveTypeForm() {
      if (this.tableData.length === 0) {
        this.$message.warning("请添加匹配问卷");
        return;
      }
      let list = [];
      this.tableData.forEach((item, index) => {
        list.push({
          examPaperId: item.examPaperId,
          sort: index
        });
      });
      let temp = {
        examPaperSelectionId: this.selectId,
        itemList: list
      };
      let res = await addRehabilitation(temp);
      if (res.code === 0) {
        this.$message.success("配置成功");
      }
    },
    handleShowDialog() {
      this.showAddQuestion = true;
    },
    handleCancel() {
      this.addCheckType();
    },
    // 重置
    handleReset() {
      if (this.checkFormData.id) {
        // 编辑
        this.handleDetailContent({
          id: this.checkFormData.id
        });
      } else {
        // 新增
        this.addCheckType();
      }
    },
    // 获取问卷详情，匹配问卷名称
    async getPageDetail(paperId) {
      let res = await questionnaireDetails({
        id: paperId
      });
      if (res.code === 0) {
        this.rowPaperId = paperId;
        this.checkFormData.title = res.data.title;
      }
    },
    // 查看
    async handleLook(row) {
      await this.getPageDetail(row.examPaperId);
      this.showQuestion = true;
    },
    // 删除
    handleDel(index) {
      this.$confirm("确定要删除当前问卷吗？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-del-confirm"
      }).then(async () => {
        this.tableData.splice(index, 1);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.health-check-config-wrap {
  height: 100%;
  width: 100%;

  .active-bg {
    background-color: #fcfcfc;
    // border: 1px dashed #1A7BFC;
  }

  .el-header {  
    padding: 0 20px;
    text-align: left;
    background: #fff;
  }
 
  .tag {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    font-family: PingFangSC-Medium, PingFang SC;
    margin-bottom: 15px;
    display: flex;
    font-weight: 500;
  }

  .tag::before {
    content: "";
    display: block;
    width: 4px;
    height: 15px;
    background: #1a7bfc;
    margin-right: 15px;
    margin-top: 2.5px;
  }

  .el-aside {
    border-radius: 6px;
    background: #ffffff;
    height: calc(100% - 68px);
    width: 313px;
    margin-right: 16px;
    height: 100%;
    padding: 20px;

    .type-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // height: 46px;
      padding: 0 5px;
      border-radius: 8px;
    }
  }

  .content-form {
    background: #ffffff;
  }

  .add-item {
    width: 100%;
    background-color: #fcfcfc;
    border: 1px dashed #d9d9d9;
    color: #333333;
  }

  .add-item-config {
    // width: 100%;
    background-color: #fcfcfc;
    border: 1px dashed #1a7bfc;
    color: #1a7bfc;
    margin-bottom: 20px;
    width: 247px;
    height: 35px;
    // margin-left:180px;
  }

  .type-name {
    font-size: 12px;
    // font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    // line-height: 46px;
  }

  .type-option {
    display: flex;
    align-items: center;

    .el-button {
      font-size: 12px;
      font-weight: 400;
      color: #1a7bfc;
      // line-height: 46px;
    }
  }

  .upload-tips {
    position: absolute;
    bottom: 0;
    left: 140px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    // line-height: 17px;
  }

  .footer-option {
    text-align: left;
    padding-left: 180px;

    .el-button {
      width: 110px;
    }
  }

  /deep/.el-table__header th {
    padding: 0;
    height: 54px;
  }

  .btn-bg {
    background-color: #1a7bfc;
  }

  .el-button--text {
    color: #1a7bfc;
  }

  .line-sepa {
    display: inline-block;
    width: 1px;
    height: 14px;
    background-color: #1a7bfc;
    margin: 0 12px;
  }

  .disable-btn {
    margin-bottom: 20px;
    width: 588px;
    margin-left: 180px;
    background: #f0f0f0;
    border-radius: 3px;
    border: 1px solid #e9e9e9;
    color: #999999;
    font-size: 12px;
  }
}
</style>
<style lang="less">
.avatar-pic .el-upload {
  border: 1px dashed #d9d9d9;
}

.avatar-uploader .el-upload {
  /* border: 1px dashed #d9d9d9; */
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 130px;
  text-align: center;
}

.avatar {
  width: 130px;
  height: 130px;
  display: block;
}

.message-del-confirm {
  .el-button--primary {
    background-color: #1a7bfc;
  }
}
</style>
